import MedicalHealthInformation from './components/MedicalHealthInformation';
import {
  MEDICAL_HEALTH_INFORMATION_BRANCH_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME,
  MEDICAL_HEALTH_INFORMATION_DETAIL_NAME,
  MEDICAL_HEALTH_INFORMATION_ERROR_NAME,
  MEDICAL_HEALTH_INFORMATION_NAME
} from './constants/constants';
import MedicalHealthInformationDetail from './components/MedicalHealthInformationDetail';
import MedicalHealthInformationError from './components/MedicalHealthInformationError';
import MedicalHealthInformationBranch from './components/MedicalHealthInformationBranch';
import MedicalHealthInformationBranchQuestionnaireResponse from './components/MedicalHealthInformationBranchQuestionnaireResponse';

export type ViewKey =
  | typeof MEDICAL_HEALTH_INFORMATION_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_BRANCH_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_DETAIL_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_ERROR_NAME;

const getViews = () => {
  return {
    MedicalHealthInformation: () => {
      return <MedicalHealthInformation />;
    },
    MedicalHealthInformationBranch: () => {
      return <MedicalHealthInformationBranch />;
    },
    MedicalHealthInformationBranchQuestionnaireResponse: () => {
      return <MedicalHealthInformationBranchQuestionnaireResponse />;
    },
    MedicalHealthInformationDetail: () => {
      return <MedicalHealthInformationDetail />;
    },
    MedicalHealthInformationError: () => {
      return <MedicalHealthInformationError />;
    }
  } as const;
};

export const GetRenderView = (targetViewKey: ViewKey) => {
  const views = getViews();
  return views[targetViewKey]();
};
export default GetRenderView;
